var _metadata, _defs, _tspan;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGimbilLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 146.78751",
    height: 146.78751,
    width: 180,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25,0,0,-1.25,0,146.7875)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1,0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "none",
      stroke: "#598a18",
      strokeWidth: 52.5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 782.359,1006.4 c 21.192,-36.537 34.707,-91.959 34.707,-154.009 0,-11.895 -0.496,-23.539 -1.449,-34.864"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "none",
      stroke: "#598a18",
      strokeWidth: 52.5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 715.602,784.203 c -105.887,0 -191.727,29.332 -191.727,65.516 0,36.179 85.84,65.511 191.727,65.511 66.183,0 124.531,-11.457 158.984,-28.882"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "none",
      stroke: "#93d222",
      strokeWidth: 52.5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 812.672,790.809 C 800.359,710.762 764.563,652.855 722.32,652.855 c -52.425,0 -94.925,89.196 -94.925,199.215 0,110.024 42.5,199.22 94.925,199.22 22.864,0 43.832,-16.97 60.219,-45.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "none",
      stroke: "#93d222",
      strokeWidth: 52.5,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 874.766,886.023 c 20.675,-10.453 32.746,-23.058 32.746,-36.628 0,-36.18 -85.84,-65.512 -191.731,-65.512"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "none",
      stroke: "#a8a7a7",
      strokeWidth: 45,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 715.711,1135.28 -0.406,16.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "none",
      stroke: "#a8a7a7",
      strokeWidth: 45,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 719.617,556.508 -0.406,16.539"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "none",
      stroke: "#a8a7a7",
      strokeWidth: 45,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 836.727,1092.09 C 968.516,1029.16 1024.34,871.309 961.402,739.52 898.473,607.73 740.617,551.91 608.828,614.844"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "none",
      stroke: "#a8a7a7",
      strokeWidth: 45,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 607.105,615.055 C 475.32,677.984 419.5,835.84 482.434,967.629 545.363,1099.41 703.215,1155.23 835.008,1092.3"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(10,10)",
    id: "g30"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text32",
    style: {
      fontVariant: "normal",
      fontWeight: "bold",
      fontSize: "44.95370102px",
      fontFamily: "Calibri",
      InkscapeFontSpecification: "Calibri-Bold",
      writingMode: "lr-tb",
      fill: "#93d222",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1,0,0,-1,3.38125,13.7629)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan34",
    y: 0,
    x: "0 28.8696 41.079601 80.594696 106.01799 118.228"
  }, "GIMBIL")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGimbilLogoLight);
export default __webpack_public_path__ + "static/media/gimbil_logo_light.cb33ef800e73d33dc05b87674675fd0a.svg";
export { ForwardRef as ReactComponent };